import NewsIcon from './NewsIcon'

export default NewsIcon
